import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {OrderRejectionCodeService} from 'app/blocks/service/api/order-rejection-code.service';
import {Resource} from 'app/constants/resource';

import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {IOrderRejectionCode} from 'app/blocks/model/order-rejection-code.model';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {OrderRejectionCode} from 'app/blocks/model/order-rejection-code.model';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';

@Injectable({
    providedIn: 'root'
})
export class OrderRejectionCodeResource extends AbstractEntityResource<IOrderRejectionCode> {
    constructor(orderRejectionCodeService: OrderRejectionCodeService, router: Router) {
        super(
            Resource.ORDER_REJECTION_CODES,
            orderRejectionCodeService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.ORDER_REJECTION_CODES, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.ORDER_REJECTION_CODES),
            (entity?) => new OrderRejectionCode(entity),
            (entity) => entity.code,
            'not_interested'
        );
    }
}
